import { getDbClassName } from '@shared/db-class'
import type { NoodlNode } from '@shared/node-v1.0.0'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import type { Item } from '@shared/types-v0.1.0'
import type { Props } from '../node/definition'
import type { SchemeData } from '../node/store'
import Node from './Node'

export default (p: Props, noodlNode: NoodlNode) => {
	// Подготовим иерархию. Она должна быть атомарной. Т.е. каждая нода содержит информацию о свзях, но связи не проложены.
	const flatNodes: Node[] = []
	Node.createHierarchy(p, flatNodes)
	// Создадим прокси нод иерархии или обновим их для реактивности.
	Node.setNodesProxy(p, flatNodes)

	const data: { [dbClass: string]: SchemeData & { items: Item[] } } = {}

	// В data выдаем только родительские схемы.
	for (const schemeData of p.store.schemesData) {
		const dbClassName = getDbClassName(schemeData.scheme.dbClass)

		// Выдаем на выход только 0 уровень, иерархию не выдаем!
		if (schemeData.path === 'root') {
			// Подготавливаем data в выходу
			data[dbClassName] = {
				...schemeData,
				items: schemeData.itemIds.map((id) => R.items[id]).filter((i) => !!i),
			}

			// Так как мы можем посчитать число страниц для пагинации только после получения данных, то делаем это здесь
			// ЕСли включена пагинация и данный класс - пагинируемый
			if (p.paginationOn && schemeData.scheme.dbClass === p.paginationClass) {
				if (schemeData.scheme.size) {
					// Рассчитываем число страниц
					const currentTotalPagesCount = Math.ceil(schemeData.total / schemeData.scheme.size)

					// Если оно не равно числу страниц в store, то обновляем
					if (p.store.totalPagesCount !== currentTotalPagesCount) {
						p.store.totalPagesCount = currentTotalPagesCount
					}
				}
			}

			// Выдаем данные для каждого класса
			if (p.outputDbClasses?.includes(dbClassName)) {
				sendOutput(
					noodlNode,
					`${dbClassName}Items`,
					schemeData.itemIds.map((id) => R.items[id]).filter((i) => !!i)
				)
				sendOutput(noodlNode, `${dbClassName}Fetched`, schemeData.fetched)
				sendOutput(noodlNode, `${dbClassName}Total`, schemeData.total)
				sendOutput(noodlNode, `${dbClassName}Aggregations`, schemeData.aggregations)
			}
		}
	}

	sendOutput(noodlNode, 'data', data)
	sendOutput(noodlNode, 'rootId', p.store.rootId)
	sendOutput(noodlNode, 'rootNode', R.nodes[p.store.rootId])
	sendOutput(noodlNode, 'schemesData', p.store.schemesData)
	sendOutput(noodlNode, 'page', p.store.page)
	sendOutput(noodlNode, 'totalPagesCount', p.store.totalPagesCount)
	sendOutput(noodlNode, 'fetching', false)
	sendSignal(noodlNode, 'fetched')
}
